<template>
<div class="">
    <div class=" backgroundcolor2 borderadius12">
        <div class="card-body text-center pt-5 pb-5">
            <div class="p-5 d-flex flex-column text-center">
                <img src="../assets/no_video.svg" class="img-fluid no-video pl-5 pr-5 pb-4 mx-auto" alt="novideo">
                <span class="proximanova-thin fontsize24 black60">{{message}}</span>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    props : ['message'],
    data(){
        return{

        }
    },
    methods : {
    }
}
</script>
<style scoped>
</style>